// extracted by mini-css-extract-plugin
export default {"go_top_button":"buttonToTop_go_top_button__-1zah","active":"buttonToTop_active__5hFgl","arrow":"buttonToTop_arrow__wu7qm"};